export enum Role {
    SuperAdmin = 'SuperAdmin',
    Student = 'Student',
    AdminStudyCenter = 'AdminStudyCenter',
    StudentStudyCenter = 'StudentStudyCenter',
}
